// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* width & height was 155px */
#timeInfo{
    width: 240px;
    height: 240px;
    background: #E5E5EA;
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 50%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
}
#timeInfo_dark{
    width: 155px;
    height: 155px;
    border-radius: 50%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #121921;
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    color: white;
}
.timer_holder{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #585858;
    margin-bottom: 0px;
}
.timer_holder #time_holder p{
    font-weight: bold;
}
#time_holder{
    display: flex;
    flex-direction: column;
    align-items: center;
}
#time{
    text-align: center;
    margin: 1px 0px 3px 0px;
    font-weight: 400 !important;
}
.bar{
    transform: rotate(rotate(-160 100 100));
}

.timer_container{
    z-index: 9;
}

#cost_amount{
    width: 50%;
    text-align: left;
    margin: 0.5rem 0 0.5rem 0;
    color: #585858;
    font-weight: bold;
}
#cost_amount_dark{
    width: 50%;
    text-align: left;
    margin: 0.5rem 0 0.5rem 0;
    color: white;
    font-weight: bold;
}
.cost_holder{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -6%;

}
.price{
    width: 10%;
    color: red;
    height: min-content;
}
.whiteList{
    color: deepskyblue;
}
#sun{
    width: 20px;
    height: 20px;
    margin-top: -10px;
    }
#moon{
        width: 17px;
        height: 17px;
        margin-left: 10px;
        margin-top: -10px;
    }
    .daily_container{
        display: flex;
        align-items: center;
    }
    .rate_container{
    display: flex;
    }
p.rate_{
    font-size: 14px;
    margin-left: 2px;
    margin-top: 0px;
}
.set_time{
text-align: center ;
margin-bottom: 0px;
margin-top: 0px;
color: rgb(255, 79, 79);
font-weight:700
}
.set_time_button{
appearance: none;
width: 90%;
border-radius: 7px;
border: 1px solid rgb(255, 79, 79);;
font-size: 10px;
padding-top: 3px;
padding-bottom: 3px;
color: rgb(255, 79, 79);
font-weight: bold;
margin-top: -5px !important;

}
.day_rate{
display: flex;
justify-content: center;
margin-top: 14%;
}
.night_rate{
    display: flex;
    justify-content: center;
    margin-top: 2px;
    }
#hours_{
    margin-left: 5px;
    font-weight: bold;
}
#cost_{
margin-left: 10px;
color: rgb(255, 79, 79);
}
.dayRate_icon{
display: flex;
align-items: center;
padding-top: 4.5%;
}
.nightRate_icon{
    display: flex;
    align-items: center;
    padding-top: 4.5%;
}
.nightRate_icon img{
    margin-left: -4.5% !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Timer/Timer.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iDAAiD;IACjD,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,iDAAiD;IACjD,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;AAC/B;AACA;IACI,uCAAuC;AAC3C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;;AAEnB;AACA;IACI,UAAU;IACV,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB;AACJ;QACQ,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;IACA,aAAa;IACb;AACJ;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;AACA,mBAAmB;AACnB,kBAAkB;AAClB,eAAe;AACf,uBAAuB;AACvB;AACA;AACA;AAGA,gBAAgB;AAChB,UAAU;AACV,kBAAkB;AAClB,kCAAkC;AAClC,eAAe;AACf,gBAAgB;AAChB,mBAAmB;AACnB,uBAAuB;AACvB,iBAAiB;AACjB,2BAA2B;;AAE3B;AACA;AACA,aAAa;AACb,uBAAuB;AACvB,eAAe;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf;AACJ;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;AACA,iBAAiB;AACjB,uBAAuB;AACvB;AACA;AACA,aAAa;AACb,mBAAmB;AACnB,iBAAiB;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,6BAA6B;AACjC","sourcesContent":["/* width & height was 155px */\n#timeInfo{\n    width: 240px;\n    height: 240px;\n    background: #E5E5EA;\n    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 50%;\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n#timeInfo_dark{\n    width: 155px;\n    height: 155px;\n    border-radius: 50%;\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #121921;\n    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n    color: white;\n}\n.timer_holder{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #585858;\n    margin-bottom: 0px;\n}\n.timer_holder #time_holder p{\n    font-weight: bold;\n}\n#time_holder{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n#time{\n    text-align: center;\n    margin: 1px 0px 3px 0px;\n    font-weight: 400 !important;\n}\n.bar{\n    transform: rotate(rotate(-160 100 100));\n}\n\n.timer_container{\n    z-index: 9;\n}\n\n#cost_amount{\n    width: 50%;\n    text-align: left;\n    margin: 0.5rem 0 0.5rem 0;\n    color: #585858;\n    font-weight: bold;\n}\n#cost_amount_dark{\n    width: 50%;\n    text-align: left;\n    margin: 0.5rem 0 0.5rem 0;\n    color: white;\n    font-weight: bold;\n}\n.cost_holder{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: -6%;\n\n}\n.price{\n    width: 10%;\n    color: red;\n    height: min-content;\n}\n.whiteList{\n    color: deepskyblue;\n}\n#sun{\n    width: 20px;\n    height: 20px;\n    margin-top: -10px;\n    }\n#moon{\n        width: 17px;\n        height: 17px;\n        margin-left: 10px;\n        margin-top: -10px;\n    }\n    .daily_container{\n        display: flex;\n        align-items: center;\n    }\n    .rate_container{\n    display: flex;\n    }\np.rate_{\n    font-size: 14px;\n    margin-left: 2px;\n    margin-top: 0px;\n}\n.set_time{\ntext-align: center ;\nmargin-bottom: 0px;\nmargin-top: 0px;\ncolor: rgb(255, 79, 79);\nfont-weight:700\n}\n.set_time_button{\n-webkit-appearance: none;\n-moz-appearance: none;\nappearance: none;\nwidth: 90%;\nborder-radius: 7px;\nborder: 1px solid rgb(255, 79, 79);;\nfont-size: 10px;\npadding-top: 3px;\npadding-bottom: 3px;\ncolor: rgb(255, 79, 79);\nfont-weight: bold;\nmargin-top: -5px !important;\n\n}\n.day_rate{\ndisplay: flex;\njustify-content: center;\nmargin-top: 14%;\n}\n.night_rate{\n    display: flex;\n    justify-content: center;\n    margin-top: 2px;\n    }\n#hours_{\n    margin-left: 5px;\n    font-weight: bold;\n}\n#cost_{\nmargin-left: 10px;\ncolor: rgb(255, 79, 79);\n}\n.dayRate_icon{\ndisplay: flex;\nalign-items: center;\npadding-top: 4.5%;\n}\n.nightRate_icon{\n    display: flex;\n    align-items: center;\n    padding-top: 4.5%;\n}\n.nightRate_icon img{\n    margin-left: -4.5% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
